module.exports = __webpack_public_path__ + "static/media/5ed79bcb72f4e5e57a748782.9a89c365.png";